import moment from "moment";
import { occupations, membershipTypes, countries } from "../constants";
import { findGetParameter, clear } from "./form-utils";

const sectors = {
    private: 0,
    kommunal: 1,
    handel: 2,
    stat: 3,
};

// Flags are booleans that determine which route through the flow the user takes.
// Possible flags:
//
// SkipUnionFlag
// SkipAkasseFlag
// Sector
// Student15MonthsPlusRuleFlag
// Student3MonthsPlusRuleFlag
// PartTimeMembershipFlag
// FlexiJobFlag
// ThirdPartyConsentFlag
// AkasseThirdPartyConsentFlag
// PartTimeEmploymentFlag
// EmployedFlag
// StudentPupilFlag
// TraineeFlag
// UnemployedFlag
// RecentGraduateFlag
// SelfEmployedFlag
// HKEducationFlag
// PracticalEducationFlag
// TheoreticalEducationFlag
// BasicEducationFlag
// PrimarySchoolFlag
// GraduationEntitledFlag
// IsPartOfGraduationEntitledEducationFlag
// AfterSchoolJobFlag
// AcquiredJobFlag
// StartedNewEducationFlag
// IsOver30Flag
// EarnsOver18KFlag
// StudentExtraIncomeFlag
// AlreadyMemberFlag
// AlreadyMemberAkasseFlag
// BenefitsEntitledFromOtherAkasseFlag
// AkasseReducedMembershipFeeFlag
// MemberOfOtherAkasseFlag
// FormerMemberOfOtherAkasseFlag
// UnderEducation
// EmployerCrmId
// GraduatedWithinLast14DaysFlag
// MaybeHasSalaryInsuranceFlag
// HasNoRelevantAfterSchoolJobFlag

const setFlagsAffectingFlow = (formValues, mergedFormValues) => {
    let flags = {};
    mergedFormValues =
        mergedFormValues != undefined ? mergedFormValues : formValues;

    //Når brugeren har valgt medlemskabstype skal flagene sættes
    switch (formValues.MembershipType) {
        case membershipTypes.Union: {
            flags.SkipAkasseFlag = true;
            flags.SkipUnionFlag = false;
            break;
        }
        case membershipTypes.UnemploymentFund: {
            flags.SkipUnionFlag = true;
            flags.SkipAkasseFlag = false;
            break;
        }
        case membershipTypes.UnionAndUnemploymentFund: {
            flags.SkipAkasseFlag = false;
            flags.SkipAkasseFlag = false;
        }
    }

    let skipUnion =
        findGetParameter("SkipUnion") ||
        findGetParameter("SkipUnionFlag") ||
        undefined;
    if (skipUnion === "true") {
        flags.SkipUnionFlag = true;
        formValues.SkipUnionFromURL = true;
    }

    let underEducationFlag = findGetParameter("undereducation");
    if (underEducationFlag === "true") {
        flags.UnderEducationFlag = true;
        formValues.UnderEducationFlag = true;
    }

    //Hvis SkipUnionFlag eller SkipAKasseFlag er sat sættes membershiptype her i koden i stedet for et brugervalg
    if (flags.SkipUnionFlag) {
        formValues.MembershipType = membershipTypes.UnemploymentFund;
    }
    if (flags.SkipAkasseFlag) {
        formValues.MembershipType = membershipTypes.Union;
    }

    //Hvis vi er kommet fra et MOS flow sættes skip flag og under education flag
    //MOS FLOW START
    if (formValues.IsAkasseOnlyMOS === true) {
        formValues.MembershipType = membershipTypes.UnemploymentFund;
        flags.SkipUnionFlag = true;
    }

    if (formValues.IsStudyPlusMOS === true) {
        flags.UnderEducationFlag = true;
    }
    //MOS FLOW SLUT

    if (
        formValues.EducationChoiceManual ||
        formValues.CompanyName ||
        formValues.CompanyCvr ||
        (formValues.EducationChoice && formValues.EducationChoice.IsHKEducation)
    ) {
        flags.Sector = sectors.private;
    }

    if (formValues.IsRecentGraduate && formValues.HasWork) {
        flags.Sector = undefined;
    }

    //Hvis brugeren i akasseflow har indtastet at de ikke har over 30 timer. Hvis man har svaret dette skal flaget for deltidsansættelse sættes højt.
    if (
        formValues.Over30Hours !== undefined &&
        formValues.Over30Hours === false
    ) {
        flags.PartTimeEmploymentFlag = true;
    }

    //Fix - Sørger for at nulstille educationchoicemanual hvis man nu er gået tilbage og har ændret så man godt kan finde sin uddannelse
    if (formValues.EducationChoice) {
        if (formValues.EducationChoice.CrmId) {
            formValues.EducationChoiceManual = undefined;
        }
    }

    //Fix - Sørger for at nulstille educationchoiceafterfinishededucationmanual hvis man nu er gået tilbage og har ændret så man godt kan finde sin uddannelse
    if (formValues.EducationChoiceAfterFinishedEducation) {
        if (formValues.EducationChoiceAfterFinishedEducation.CrmId) {
            formValues.EducationChoiceAfterFinishedEducationManual = undefined;
        }
    }

    //Sætter flaget parttimeemployment til false hvis man har over 30 timer . Hvis man har svaret dette skal det ikke være muligt at vælge deltidsmedlemsskab i akassen.
    if (formValues.Over30Hours) {
        flags.PartTimeEmploymentFlag = false;
    }

    if (flags.PracticalEducationFlag) {
        formValues.ManagementResponsibility = "1"; //"Elever og lærlinge" is always the choice for Praktiske Elever
        formValues.Over30Hours = true; //30+ hours is always the choice for Praktiske Elever
    }

    //Skal også laves for førtidspensionister senere hen, flaget eksisterer dog ikke endnu
    //Fleksjobbere har altid FSOL
    if (formValues.ReceivesWageSubsidies) {
        flags.FlexiJobFlag = true;
        flags.SolidarityDuesEligibleFlag = true;
    }

    //Medlemmer fra grønland og færøerne har altid FSOL medmindre de er studerende!
    //Selve flaget for solidaritydueseligble bliver sat længere nede.
    if (
        (mergedFormValues.Country === countries.Faeroerne ||
            mergedFormValues.Country === countries.Groendland) &&
        mergedFormValues.MemberSituation &&
        mergedFormValues.MemberSituation != occupations.student &&
        mergedFormValues.MemberSituation != occupations.trainee &&
        mergedFormValues.MemberSituation != occupations.vocationalEducation
    ) {
        formValues.SolidarityDuesEligible = true;
        flags.MaybeHasSalaryInsuranceFlag = false;
    }

    //Hvis MonethlyIncomeReason er true betyder det at brugeren har svaret at de er på revalidering når spørgsmålet om hvorfor deres indkomst er over akassengrænsen bliver besvaret.
    //Hvis RecievesPublicWelfare er true betyder det at brugeren har svaret ja til at være på offentlig forsørgelse
    if (
        formValues.MonthlyIncomeLimitClarification === true ||
        formValues.RecievesPublicWelfare === true
    ) {
        flags.SalaryContributionFlag = true;
    }

    //Hvis brugeren har bedt om et deltidsmedlemskab i akasseflow sættes flaget for deltids akassemedlemsskab her.
    if (formValues.PartTimeMembership !== undefined) {
        switch (formValues.PartTimeMembership) {
            case "true":
                flags.PartTimeMembershipFlag = true;
                break;
            default:
                flags.PartTimeMembershipFlag = false;
                break;
        }
    } else if (flags.SkipAkasseFlag && flags.PartTimeEmploymentFlag)
        flags.PartTimeMembershipFlag = true;

    //Dette tjek bliver sat på da formValues for membersituation åbenbart godt kan have indhold selvom vi er på et helt andet trin.
    //Hvis formvalues.IsRecentGraduate er false er der ingen tvivl og vi kan selvfølgelig gå videre
    //Hvis den derimod er undefined og der eksisterer en true på den i mergedformvalues betyder det at vi har med en recentgraduate at gøre.
    //Dette tjek burde kunne slettes da formvalues altid kun burde indeholde fra det enkelte step.
    if (
        formValues.MemberSituation &&
        (formValues.IsRecentGraduate === false ||
            (formValues.IsRecentGraduate != true &&
                mergedFormValues.IsRecentGraduate != true))
    ) {
        switch (formValues.MemberSituation) {
            case occupations.employed:
                flags.EmployedFlag = true;
                flags.StudentPupilFlag = false;
                flags.TraineeFlag = false;
                flags.UnemployedFlag = false;
                flags.SelfEmployedFlag = false;

                break;
            case occupations.student:
                flags.StudentPupilFlag = true;
                flags.EmployedFlag = false;
                flags.TraineeFlag = false;
                flags.UnemployedFlag = false;
                flags.SelfEmployedFlag = false;
                break;
            case occupations.trainee:
                flags.TraineeFlag = true;
                flags.StudentPupilFlag = false;
                flags.EmployedFlag = false;
                flags.UnemployedFlag = false;
                flags.SelfEmployedFlag = false;
                break;
            case occupations.unemployed:
                flags.UnemployedFlag = true;
                flags.TraineeFlag = false;
                flags.StudentPupilFlag = false;
                flags.EmployedFlag = false;
                flags.SelfEmployedFlag = false;
                break;
            case occupations.vocationalEducation:
                flags.StudentPupilFlag = true;
                flags.UnemployedFlag = false;
                flags.TraineeFlag = false;
                flags.EmployedFlag = false;
                flags.SelfEmployedFlag = false;
                break;
            case occupations.selfEmployed:
                flags.SelfEmployedFlag = true;
                flags.StudentPupilFlag = false;
                flags.UnemployedFlag = false;
                flags.TraineeFlag = false;
                flags.EmployedFlag = false;
                break;
        }
    }

    if (formValues.Workplace && formValues.Workplace.CrmId) {
        flags.EmployerCrmId = formValues.Workplace.CrmId;
    }

    if (formValues.WorkplaceEnteredManually) {
        flags.ManualWorkplaceFlag = true;
    }

    //For at kunne parse rigtigt i backenden skal vi lave en membershipstartdate der er i iso format
    if (formValues.MembershipStartDate) {
        formValues.MembershipStartDateIso = moment(
            formValues.MembershipStartDate
        )
            .startOf("day")
            .format("YYYY-MM-DD");
    }

    //Sæt flag der relaterer sig til udd. afslutningsdato
    if (
        formValues.EducationEndDate != null &&
        formValues.EducationEndDate != ""
    ) {
        formValues.EducationEndDate = moment(formValues.EducationEndDate)
            .startOf("day")
            .format("YYYY-MM-DD");
        flags.GraduatedWithinLast14DaysFlag = moment(
            formValues.EducationEndDate
        )
            .startOf("day")
            .isBetween(
                moment().subtract(14, "days").startOf("day"),
                moment().startOf("day"),
                "day",
                "[]"
            );
        flags.Student15MonthsPlusRuleFlag = moment(formValues.EducationEndDate)
            .startOf("day")
            .isAfter(moment().add(15, "months"), "day");
        flags.Student3MonthsPlusRuleFlag = moment(formValues.EducationEndDate)
            .startOf("day")
            .isAfter(moment().add(3, "months"), "day");
        flags.Graduated = moment(formValues.EducationEndDate)
            .startOf("day")
            .isBefore(moment(), "day");
        flags.Under3MonthsTillEducationEndFlag = moment(
            formValues.EducationEndDate
        )
            .startOf("day")
            .isBetween(
                moment().startOf("day"),
                moment().add(3, "months").endOf("day"),
                "day",
                "(]"
            );
        formValues.GraduatedWithinLast14DaysFlag =
            flags.GraduatedWithinLast14DaysFlag;
        formValues.Under3MonthsTillEducationEndFlag =
            flags.Under3MonthsTillEducationEndFlag;
    }

    //Her tjekker vi om man manuelt har svaret at der er under 14 dage siden man har afsluttet sin uddannelse. Dette er relevant for at kunne vise en mere korrekt pris under membershiptype steppet.
    else if (
        !mergedFormValues.EducationEndDate &&
        formValues.UnderFourteenDaysSinceEducationEnd
    ) {
        if (formValues.UnderFourteenDaysSinceEducationEnd === true) {
            flags.GraduatedWithinLast14DaysFlag = true;
            formValues.GraduatedWithinLast14DaysFlag = true;
        } else {
            flags.GraduatedWithinLast14DaysFlag = false;
            formValues.GraduatedWithinLast14DaysFlag = false;
        }
    }

    //Logik der relaterer sig til RecentGraduate.
    //RecentGraduate betyder her at man er dimmitentberettiget
    if (
        formValues.EducationEndDate != null &&
        formValues.EducationEndDate != ""
    ) {
        //Sæt som recentgraduate hvis (Er udlært, men under 14 dage siden) ELLER (Ikke udlært, men under 3 måneder tilbage)
        if (
            (flags.Graduated === true &&
                flags.GraduatedWithinLast14DaysFlag === true) ||
            (!flags.Graduated && !flags.Student3MonthsPlusRuleFlag)
        ) {
            if (
                mergedFormValues.MemberSituation !== occupations.trainee &&
                formValues.EducationChoice &&
                formValues.EducationChoice.IsHKEducation &&
                formValues.EducationChoice.DimittendBerettiget
            ) {
                formValues.IsRecentGraduate = true;
                flags.RecentGraduateFlag = true;
            }
            //Hvis man er på en ikke-hk-uddannelse men det
            else {
                flags.GraduatedWithinLast14DaysFlag = true;
            }

            /*
            //Efterfølgende sættes andre flag til false da man i MKAT tabellen ikke kan være eks. Employed samtidig med Recentgraduate.
            //Det har altså ikke noget at gøre med hvad ens reele livssituation er.
            flags.EmployedFlag = false;
            flags.StudentPupilFlag = false;
            flags.UnemployedFlag = false;
            flags.SelfEmployedFlag = false;
            */
        }

        //Hvis brugeren indtaster en uddannelses slutdato der enten er mindre end 14 dage siden eller der er under 3 måneder til,
        //Men efterfølgende forttyder og går tilbage og sætter en anden sluddato skal vi nulstille så man ikke er recentgraduate mere.
        //Dette gøres herunder
        //Vi tjekker på om man er recentgraduate, og om det på trods af det hverken er inden for de seneste 14 dage man er udlært eller der er under 3 måneder til. Dette kan nemlig kun lade sig gøre hvis man har fortrudt og efterfølgende har ændret sin slutdato
        else if (mergedFormValues.IsRecentGraduate) {
            formValues.IsRecentGraduate = false;
            flags.RecentGraduateFlag = false;

            /*
            switch (mergedFormValues.MemberSituation) {
                case occupations.employed:
                    flags.EmployedFlag = true;
                    break;
                case occupations.selfEmployed:
                    flags.SelfEmployedFlag = true;
                    break;
                case occupations.student:
                case occupations.vocationalEducation:
                    flags.StudentPupilFlag = true;
                    break;
                case occupations.unemployed:
                    flags.UnemployedFlag = true;
                    break;
            }
            */
        }
    }
    //Vigtigt at tjekke i mergedformvalues i stedet for en normal else. Ellers ville dette blive nulstillet hver gang man er på et trin der ikke indeholder noget med uddannelse.
    else if (!mergedFormValues.EducationEndDate) {
        //Vi nulstiller altid flaget så det ikke kan "hænge"
        flags.RecentGraduateFlag = false;
        formValues.IsRecentGraduate = false;
    }

    //Vi spørger først efter uddannelsesvalg om man har haft bopæl gennem hele uddannelsen i DK. Hvis man ikke har kan man ikke få dimmitentdagpenge og er altså ikke recentgraduate
    if (formValues.HasResidence === false) {
        flags.RecentGraduateFlag = false;
        formValues.IsRecentGraduate = false;
    }

    //Vi laver en string værdi med uddannelsesnavnet som backenden kan læse.
    if (formValues.EducationChoice) {
        formValues.EducationChoiceName = formValues.EducationChoice.Education;
    }

    if (formValues.StudyJob === true) {
        flags.AfterSchoolJobFlag = true;
    } else if (formValues.StudyJob === false) {
        flags.AfterSchoolJobFlag = false;
    }

    if (formValues.HasWork) {
        flags.AcquiredJobFlag = true;
    }

    if (formValues.StartNewEducation) {
        flags.StartedNewEducationFlag = true;
    }

    if (
        formValues.EducationChoiceAfterFinishedEducation?.IsPractical === true
    ) {
        formValues.StartNewEducationIsPractical = true;
    }

    if (formValues.Age >= 30) {
        flags.IsOver30Flag = true;
    }

    if (
        formValues.SalaryInsurance === "HasSalaryInsurance" ||
        formValues.SalaryInsurance === "NoKnowledgeOfSalaryInsurance"
    ) {
        flags.MaybeHasSalaryInsuranceFlag = true;
    }

    if (formValues.MonthlyIncomeOverLimit) {
        flags.EarnsOver18KFlag = true;
    }

    if (formValues.SalaryFromOtherThanEmployer) {
        flags.StudentExtraIncomeFlag = true;
    }

    if (formValues.BenefitsEntitledFromOtherAkasse) {
        flags.BenefitsEntitledFromOtherAkasseFlag = true;
    }

    if (formValues.AkasseReducedMembershipFee) {
        flags.AkasseReducedMembershipFeeFlag = true;
    }

    if (formValues.HasUnemploymentInsuranceFund) {
        flags.MemberOfOtherAkasseFlag = true;
    }

    if (formValues.HasPreviousUnemploymentInsuranceFund) {
        flags.FormerMemberOfOtherAkasseFlag = true;
    }

    if (formValues.SolidarityDuesEligible) {
        flags.SolidarityDuesEligibleFlag = true;
    }

    if (
        formValues.EducationChoice &&
        formValues.EducationChoice.DunCode !== "0" &&
        !formValues.EducationChoiceManual
    ) {
        flags.HKEducationFlag = formValues.EducationChoice.IsHKEducation;
        flags.PracticalEducationFlag = formValues.EducationChoice.IsPractical;
        flags.TheoreticalEducationFlag =
            formValues.EducationChoice.IsTheoretical;
        flags.BasicEducationFlag = formValues.EducationChoice.IsBasic;
        flags.PrimarySchoolFlag = formValues.EducationChoice.IsFolkeskole;

        //Flag sættes hvis man er på en dimmitentberettiget uddannelse eller er på en uddannelse der er en del af en dimmitentberettiget uddannelse (Eksempelvis mediegrafiker basisuddannelse)
        if (
            formValues.EducationChoice.DimittendBerettiget === true ||
            formValues.EducationChoice.IsPartOfDimittendBerettigetUddannelse ===
                true
        ) {
            flags.PartOfOrGraduationEntitledFlag = true;
        } else {
            flags.PartOfOrGraduationEntitledFlag = false;
        }
    }

    //Hvis din uddannelse er indtastet manuelt får du teoretisk/praktisk medlemstilstand efter hvilken situation du har valgt, og ikke direkte fra udd. databasen
    //Indmeldelsen bliver også sendt til manuel behandling med en kommentar i feltet.
    else if (
        formValues.EducationChoiceManual &&
        (mergedFormValues.MemberSituation === occupations.student ||
            mergedFormValues.MemberSituation === occupations.trainee)
    ) {
        flags.ProcessManuallyFlag = true;

        switch (mergedFormValues.MemberSituation) {
            case occupations.student:
                flags.TheoreticalEducationFlag = true;
                break;
            case occupations.vocationalEducation:
                flags.PracticalEducationFlag = true;
                break;
        }
    }

    if (formValues.ConsentRecieveOffersFromBusinessPartners) {
        flags.ThirdPartyConsentFlag = true;
    }

    if (formValues.ConsentRecieveFromUnemploymentFund) {
        flags.AkasseThirdPartyConsentFlag = true;
    }

    console.log("merged form values", mergedFormValues);
    console.log("flags", flags);
    return flags;
};

// Prepare data for backend
function mapFormData(formValues, step, mergedFormValues) {
    return {
        Component: step.Component,
        Variant: step.Variant,
        ...setFlagsAffectingFlow(formValues, mergedFormValues),
        formValues: Object.assign({}, formValues),
    };
}

export default mapFormData;
